import { I18nLanguage } from '../translation/language.enum';

export const i18nConfig = {
  language: I18nLanguage.enUS,
  bulkuploadFileTemplateVersion: '0.1_en-us',
  bulkuploadFileTemplateDateFormatIsDMY: false,
};
